// @ts-nocheck

import { useAtomValue } from 'jotai';
import { dcbAtom } from '@shared/store/slice-atoms';
import { useEffect } from 'react';
import { appendSrcScript } from '@shared/utils/general';
import { isIQFastLink } from '@entities/operator/model/utils';
import { isIQ } from '@entities/country';

/* global Detector */

export const useIQFastLinkAntifraud = () => {
  const { homeData, subscribeData, operator } = useAtomValue(dcbAtom);

  const isIQFastlink = isIQ(homeData.country) && isIQFastLink(subscribeData?.operatorName || operator?.value)

  const antifraudScript = subscribeData?.antifraudScript || null;

  const handleInjectScript = () => {
    const onLoad = () => {
      const ids = {
        form: 'otp-pin-form',
        confirm_button: 'submit-otp',
        cancel_button: 'cancel-otp',
        pin_input: 'pin-input-full',
      };

      const partner = subscribeData?.apiSubscribeCustomerID || '';
      const service = subscribeData?.apiSubscribeServiceID || '';
      const fraudToken = null;

      const detector = new Detector(ids, partner, service, fraudToken, {});

      detector.setup();
    };

    appendSrcScript(antifraudScript, onLoad);
  };

  useEffect(() => {
    if (!isIQFastlink || !antifraudScript) return;

    handleInjectScript();
  }, [isIQFastlink, antifraudScript]);

  return {
    isIQFastlink
  };
};
